import LegalLayout, { H2, P, UL, B } from "./LegalLayout";

export default function Cookies() {
    return (
        <LegalLayout title="Politica Cookie" updated="iunie 2026">
            <H2>1. Ce sunt cookie-urile</H2>
            <P>
                Cookie-urile sunt fișiere text de mici dimensiuni, stocate pe dispozitivul dumneavoastră atunci
                când vizitați un site. Ele permit site-ului să funcționeze corect, să rețină preferințe și să
                genereze statistici anonime de utilizare.
            </P>

            <H2>2. Ce cookie-uri folosim</H2>
            <UL
                items={[
                    <><B>Cookie-uri strict necesare</B> — asigură funcționarea de bază a site-ului (de ex. păstrarea sesiunii de administrare pentru personalul autorizat). Acestea nu pot fi dezactivate.</>,
                    <><B>Cookie-uri de analiză</B> — ne ajută să înțelegem cum este utilizat site-ul (pagini vizitate, durata vizitei), în formă agregată și pseudonimizată. Folosim instrumente de tip analytics (de ex. PostHog și Google Analytics 4 cu anonimizarea adresei IP). Acestea se încarcă <B>doar după ce vă exprimați acordul</B> în bannerul de consimțământ afișat la prima vizită.</>,
                ]}
            />
            <P>Site-ul <B>nu folosește</B> cookie-uri de publicitate comportamentală și nu vinde date către terți.</P>

            <H2>3. Cookie-uri ale terților</H2>
            <P>
                Serviciile de analiză menționate pot plasa propriile cookie-uri. Politicile acestora sunt
                disponibile pe site-urile furnizorilor: Google (
                <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer" className="underline">
                    policies.google.com
                </a>
                ) și PostHog (
                <a href="https://posthog.com/privacy" target="_blank" rel="noopener noreferrer" className="underline">
                    posthog.com/privacy
                </a>
                ).
            </P>

            <H2>4. Cum controlați cookie-urile</H2>
            <P>
                Puteți șterge sau bloca cookie-urile din setările browserului dumneavoastră. Alegerea făcută
                în bannerul nostru de consimțământ este salvată local, în browser; pentru a o modifica,
                ștergeți datele site-ului din browser și reîncărcați pagina. Rețineți că blocarea
                cookie-urilor strict necesare poate afecta funcționarea site-ului. Instrucțiuni pentru cele mai
                utilizate browsere:
            </P>
            <UL
                items={[
                    <a key="c" href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="underline">Google Chrome</a>,
                    <a key="f" href="https://support.mozilla.org/ro/kb/cookie-urile" target="_blank" rel="noopener noreferrer" className="underline">Mozilla Firefox</a>,
                    <a key="s" href="https://support.apple.com/ro-ro/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="underline">Safari</a>,
                    <a key="e" href="https://support.microsoft.com/ro-ro/microsoft-edge" target="_blank" rel="noopener noreferrer" className="underline">Microsoft Edge</a>,
                ]}
            />

            <H2>5. Contact</H2>
            <P>
                Pentru orice întrebare legată de utilizarea cookie-urilor, ne puteți scrie la{" "}
                <B>oferte@optimsafe.ro</B>.
            </P>
        </LegalLayout>
    );
}
